// @flow
import React from "react";
import "./styles.css";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as icons from "@fortawesome/free-solid-svg-icons";

type PropsType = { children: any, className?: string, isOpen: boolean, onClose: any => void };

export const Modal = ({ isOpen, children, className, onClose }: PropsType): any => (
    <div className={ classNames("modal", { "is-open": isOpen, className }) }>
        <button className={ "modal--close-button" } onClick={ onClose }>

            <span><FontAwesomeIcon icon={ icons.faTimesCircle }/></span>
        </button>
        {children}
    </div>
);

